import {
    GET_TRANSACTION_COMMENTS,
    GET_TRANSACTION_COMMENTS_SUCCESS,
    GET_TRANSACTION_COMMENTS_FAILED,

    SUBMIT_TRANSACTION_COMMENT_FORM,
    SUBMIT_TRANSACTION_COMMENT_FORM_SUCCESS,
    SUBMIT_TRANSACTION_COMMENT_FORM_FAILED,

    DELETE_TRANSACTION_COMMENT,
    DELETE_TRANSACTION_COMMENT_SUCCESS,
    DELETE_TRANSACTION_COMMENT_FAILED,
} from '../../constants/actionTypes';

const INIT_STATE = {
    loading: false,
    transactionComments: [],
    submittingForm: false,
    error: null,
    deleting: false,
};

const CountryReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_TRANSACTION_COMMENTS:
            return { ...state, loading: true };
        case GET_TRANSACTION_COMMENTS_SUCCESS: 
            return { ...state, transactionComments: action.payload.data, total: action.payload.total,  loading: false, error: null };
        case GET_TRANSACTION_COMMENTS_FAILED:
            return { ...state, error: action.payload, loading: false };

        case SUBMIT_TRANSACTION_COMMENT_FORM:
            return { ...state, error: null, submittingForm: true };
        case SUBMIT_TRANSACTION_COMMENT_FORM_SUCCESS:
            const alreadyExists = state.transactionComments.find((item) => item.id === action.payload.id);
            let transactionComments;
            let total = state.total;
            if (!alreadyExists) {
                transactionComments = [...state.transactionComments, action.payload];
                total += 1;
            } else {
                transactionComments = state.transactionComments.map((item) => {
                if (item.id === action.payload.id) {
                  return action.payload;
                }
                return item;
              });
            }
            return { ...state, total,  transactionComments, submittingForm: false };
        case SUBMIT_TRANSACTION_COMMENT_FORM_FAILED:
            return { ...state, error: action.payload, submittingForm: false };

        case DELETE_TRANSACTION_COMMENT:
            return { ...state, error: null, deleting: true };
        case DELETE_TRANSACTION_COMMENT_SUCCESS:
            return { ...state, total: state.total - 1, transactionComments: state.transactionComments.filter(item => item.id !== action.payload) , deleting: false };
        case DELETE_TRANSACTION_COMMENT_FAILED:
            return { ...state, error: action.payload, deleting: false };
        default: return { ...state };
    }
}

export default CountryReducer;